// extracted by mini-css-extract-plugin
export default {"items":"Sideview_items__lgZ8m","sideview":"Sideview_sideview__0hfLK"};